<template>
	<!-- 销售订单详情 -->
	<div v-if="showSalesOrder">
		<el-form :inline="true" :model="formInline" class="user-search">
			<el-form-item label="订单编号：">
				<el-input v-model="formInline.code" placeholder="请输入订单编号" clearable size="small" @change="inputChange"></el-input>
			</el-form-item>
			<el-form-item label="订单状态：">
				<el-select v-model="formInline.state" placeholder="请选择订单状态" clearable size="small" @change="inputChange">
					<el-option v-for="item in stateList" :key="item.code" :label="item.name" :value="item.code"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="订单来源：">
				<el-select v-model="formInline.orderSource" placeholder="请选择订单来源" clearable size="small" @change="inputChange">
					<el-option v-for="item in orderSourceList" :key="item.code" :label="item.name" :value="item.code"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="是否确认：">
				<el-select v-model="formInline.isConfirm" placeholder="请选择是否确认" clearable size="small" @change="inputChange">
					<el-option label="全部" :value="null"></el-option>
					<el-option label="已确认" :value="true"></el-option>
					<el-option label="未确认" :value="false"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-button v-if="$checkBtnPermission('/salesOrder/index', 'viewPage')" size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
			</el-form-item>
		</el-form>
		<STable :columns="columnsData" :data="listData" :loading="loading" border stripe @get-data="getListData">
			<template #code>
				<el-table-column label="订单号" width="220" align="center">
					<template #default="scope">
						<el-link type="primary" :underline="false" @click="handleDetail(scope.row)">
							{{ scope.row.code }}
						</el-link>
					</template>
				</el-table-column>
			</template>
			<template #stateStr>
				<el-table-column label="状态" width="90" align="center">
					<template #default="scope">
						<el-tag v-if="scope.row.state === 1" type="warning">{{ scope.row.stateStr }}</el-tag>
						<el-tag v-else-if="scope.row.state === 2" type="danger">{{ scope.row.stateStr }}</el-tag>
						<el-tag v-else type="success">{{ scope.row.stateStr }}</el-tag>
					</template>
				</el-table-column>
			</template>
			<template #isConfirm>
				<el-table-column label="是否确认" width="120" align="center">
					<template #default="scope">
						<el-tag v-if="scope.row.isConfirm" type="success">已确认</el-tag>
						<el-tag v-else type="danger">未确认</el-tag>
					</template>
				</el-table-column>
			</template>
			<template #arrearsMoney>
				<el-table-column label="欠款金额" min-width="110" align="center">
					<template #default="scope">
						<span style="color: #f56c6c; font-weight: 600; white-space: nowrap" v-money="(scope.row.totalMoney - scope.row.totalPayMoney)">￥{{ (scope.row.totalMoney - scope.row.totalPayMoney).toFixed(2) }} 元</span>
					</template>
				</el-table-column>
			</template>
		</STable>
		<!-- 分页组件 -->
		<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>

		<detail v-if="isShowDetail" ref="detail"></detail>
	</div>
</template>

<script>
import { GetSalesOrderPageList } from "@/api/productApi.js";
import { GetEnumConfigListByCode } from "@/api/enumApi.js";
import detail from "@/views/product/sales/detail.vue";
export default {
	data() {
		return {
			pageShow: true,
			loading: false, // 显示加载
			listData: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				storeKeyId: "",
				isConfirm: null,
				code: "",
				vipNo: "",
				state: 0,
				orderSource: 0,
				customerKeyId: "",
				startTime: null,
				endTime: null
			},
			columnsData: [], //显示列
			listColumns: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "80",
					isKeep: true
				},
				{
					prop: "storeName",
					label: "门店名称",
					isKeep: true,
					minWidth: "100",
					align: "center",
				},
				{
					slot: "code",
					label: "订单号",
					minWidth: "180",
					isKeep: true,
					align: "center",
				},
				{
					prop: "customer.name",
					label: "顾客姓名",
					minWidth: "90",
					align: "center",
				},
				{
					prop: "customer.phone",
					label: "顾客手机号",
					minWidth: "120",
					align: "center",
				},
				{
					slot: "stateStr",
					label: "状态",
					minWidth: "80",
					align: "center",
				},
				{
					prop: "vipInfo.vipNo",
					label: "会员号",
					minWidth: "120",
					align: "center"
				},
				{
					prop: "vipInfo.balance",
					label: "会员余额",
					minWidth: "120",
					align: "center",
					isMoney: true,
					moneyType: "income"
				},
				{
					prop: "totalProductMoney",
					label: "订单金额",
					minWidth: "120",
					align: "center",
					isMoney: true,
					moneyType: "normal"
				},
				{
					prop: "totalMoney",
					label: "收费金额",
					minWidth: "120",
					align: "center",
					isMoney: true,
					moneyType: "normal"
				},
				{
					prop: "totalPayMoney",
					label: "总支付金额",
					minWidth: "120",
					align: "center",
					isMoney: true,
					moneyType: "normal"
				},
				{
					slot: "arrearsMoney",
					label: "欠款金额",
					minWidth: "120",
					align: "center"
				},
				{
					prop: "creator",
					label: "经办人",
					width: "120",
					align: "center"
				},
				{
					prop: "createTime",
					label: "下单时间",
					width: "170",
					align: "center"
				},
				{
					slot: "isConfirm",
					label: "是否确认",
					minWidth: "120",
					align: "center"
				},
				{
					prop: "confirmUserName",
					label: "确认人",
					align: "center"
				},
				{
					prop: "confirmDate",
					label: "确认时间",
					align: "center",
					width: "170"
				},
				{
					slot: "operation",
					label: "操作",
					minWidth: "120",
					align: "center",
					fixed: "right"
				}
			],
			stateList: [],
			orderSourceList: [],
			showSalesOrder: false,
			isShowDetail: false
		};
	},
	// 注册组件
	components: {
		detail
	},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
	},
	computed: {},
	methods: {
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		//展示销售订单详情
		showSalesOrderRecord(customerKeyId) {
			this.showSalesOrder = true;
			this.formInline.customerKeyId = customerKeyId;
			this.getListData();
			this.getOrderStatusList();
			this.getOrderSourceList();
			this.isShowDetail = false;
		},
		//关闭销售订单详情
		closeSalesOrderRecord() {
			this.showSalesOrder = false;
			this.formInline.customerKeyId = "";
		},
		// 获取列表
		getListData() {
			this.loading = true;
			GetSalesOrderPageList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		inputChange(val) {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		//获取订单来源
		getOrderSourceList() {
			GetEnumConfigListByCode({
				code: "StoreOrderSource"
			})
				.then((res) => {
					if (res.code == 1) {
						this.orderSourceList = [];
						res.data.forEach((item) => {
							this.orderSourceList.push({
								code: parseInt(item.code),
								name: item.name
							});
						});
						this.orderSourceList.unshift({
							code: 0,
							name: "全部"
						});
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		//获取销售订单状态
		getOrderStatusList() {
			GetEnumConfigListByCode({
				code: "SalesOrderState"
			})
				.then((res) => {
					if (res.code == 1) {
						this.stateList = [];
						res.data.forEach((item) => {
							this.stateList.push({
								code: parseInt(item.code),
								name: item.name
							});
						});
						this.stateList.unshift({
							code: 0,
							name: "全部"
						});
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		// 点击详情按钮
		handleDetail(row) {
			this.isShowDetail = true;
			this.$nextTick(() => {
				this.$refs.detail.getDetail(row);
			});
		}
	}
};
</script>

<style scoped></style>
